import { Static, Type } from "@sinclair/typebox";

export const UserPlatform = Type.Union([Type.Literal("desktop"), Type.Literal("extension"), Type.Literal("platform")]);

export type UserPlatformType = Static<typeof UserPlatform>;
